<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header" v-if="this.remindStatus==0">关闭提醒</h3>
      <h3 slot="header" class="modal-header" v-if="this.remindStatus==1">关闭</h3>
      <div>
        <Input type="textarea" :rows="4" :maxlength="150"  placeholder="请输入关闭原因" v-model="remark"/>
      </div>
      <br/>
      <h5 style="color: red" v-if="this.remindStatus==0">关闭后，系统将不再触发提醒，请和客户协商后关闭</h5>
      <Br/>
    </Modal>
  </div>
</template>

<script>

  import {closeRemind} from "api/roomRemind";

  export default {
    name: "CloseRemind",
    props: {
      n: {
        type: Number,
        default: 0
      },
      remindFid: {
        type: String,
        default: ''
      },
      remindStatus: {
        type: Number,
        default: 0
      }
    },
    watch: {
      n() {
        this.remark = ''
        this.isShow = true
      },
    },
    data() {
      return {
        isShow: false,
        remark:'',
        loading: true
      }
    },
    methods: {
      ok() {
        if(this.remark==null||this.remark==''){
          this.$Message.error('请录入关闭原因！');
          this.changeLoading()
          return
        }
        let param ={closeReason:this.remark,fid:this.remindFid}
        closeRemind(param).then(res => {
          this.$Message.success('关闭成功！')
          this.isShow=false
          this.$emit('refresh')
        }).catch( () => {
          this.changeLoading()
          return
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
    },
    created() {
    }

  }
</script>

<style scoped>

  .input-width {
    width: 150px;
    margin-bottom: 10px;
  }


</style>
